import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Params, Router} from "@angular/router";
import {HttpService} from "../../services/http.service";
import {AppConfig} from "../../app.config";
import {Meta, Title} from "@angular/platform-browser";
import {Subscription} from "rxjs/Subscription";

@Component({
    selector: 'app-blog-details',
    templateUrl: './blog-details.component.html'
})
export class BlogDetailsComponent implements OnInit, OnDestroy {
    public blog = null;
    public AppConfig = AppConfig;
    public sub: Subscription;
    public lastComments: any;

    public getBlogLink(blog) {
        return AppConfig.baseUrl + '/blog/details/' + blog.title.replace(' ', '-') + '-' + blog.id_article;
    }

    constructor(private router: Router, private activatedRoute: ActivatedRoute, public http: HttpService,
                private titleService: Title,
                private meta: Meta) {

        this.sub = router.events.subscribe((val) => {
            if (val instanceof NavigationEnd) {
                const blogId = this.activatedRoute.snapshot.params['id'].split('-');
                this.http.get(AppConfig.baseUrlApi + 'articles/api_article?article_id=' + blogId[blogId.length - 1]).subscribe(response => {
                    this.blog = response.content;
                    this.meta.updateTag({name: 'og:url', content: this.getBlogLink(this.blog)});
                    this.meta.updateTag({name: 'og:title', content: this.blog.title});
                    this.meta.updateTag({name: 'og:description', content: this.blog.short_content});
                    this.meta.updateTag({name: 'og:image', content: AppConfig.baseUrlApi + 'public/images/articles/' + this.blog.main_picture});
                    this.meta.updateTag({name: 'description', content: this.blog.short_content});
                    this.meta.updateTag({name: 'keywords', content: this.blog.short_content});
                    this.titleService.setTitle(this.blog.title);
                    this.getLastComments();
                }, error => {
                    console.log(error);
                });
            }



        }, error => {
            console.log(error);
        });
    }

    ngOnInit() {
    }

    ngOnDestroy() {
        this.sub.unsubscribe();
    }

    getLastComments() {
        this.http.get(AppConfig.baseUrlApi + 'comments/api_comments?dir=DESC&limit=2').subscribe(response => {
            this.lastComments = response.content;
        }, error => {
            console.log(error);
        });
    }
}



// WEBPACK FOOTER //
// /home3/usalinks/public_html/ally-book-source/src/app/blog/blog-details/blog-details.component.ts